import { daoOauthScopesGet } from 'dao/oauthportal-dao';

// ------------------------------------
// Constants
// ------------------------------------

export const OAUTHPORTAL_SCOPES_GET = 'OAUTHPORTAL_SCOPES_GET';
export const OAUTHPORTAL_SCOPES_GET_SUCCESS = 'OAUTHPORTAL_SCOPES_GET_SUCCESS';
export const OAUTHPORTAL_SCOPES_GET_FAILURE = 'OAUTHPORTAL_SCOPES_GET_FAILURE';


// ------------------------------------
// Initial State
// ------------------------------------
export const initialState = {
  data: {
    scopes: []
  },

  // generic or global properties go here
  isLoading: false,
};

// ------------------------------------
// Selectors
// ------------------------------------
export const orgPortalPermissionsIsLoading = (state) => state.oauthPortal && state.oauthPortal.isLoading;
export const orgPortalScopes = (state) => (state.oauthPortal && state.oauthPortal.data && state.oauthPortal.data.scopes) || [];

// ------------------------------------
// Actions
// ------------------------------------

export const orgPortalScopesGetSuccess = (payload = {}) => ({
  type: OAUTHPORTAL_SCOPES_GET_SUCCESS,
  payload,
});

export const orgPortalScopesGetFailure = (payload = {}) => ({
  type: OAUTHPORTAL_SCOPES_GET_FAILURE,
  payload,
});

export const oauthPortalScopesGet = () => (dispatch) => {
  dispatch({
    type: OAUTHPORTAL_SCOPES_GET,
  });
  return daoOauthScopesGet()
    .then(
      response => dispatch(orgPortalScopesGetSuccess(response.data)),
      ex => dispatch(orgPortalScopesGetFailure(ex)),
    );
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [OAUTHPORTAL_SCOPES_GET]: (state) => ({...state, isLoading: true}),
  [OAUTHPORTAL_SCOPES_GET_SUCCESS]: (state, action) => {
    if (typeof action.payload === 'object') {
      return {
        ...state,
        data: {
          ...state.data,
          scopes: action.payload
        },
        isLoading: false,
      };
    }
    return {...state, isLoading: false};
  },
  [OAUTHPORTAL_SCOPES_GET_FAILURE]: (state) => ({
    ...state,
    isLoading: false,
  }),
};

// ------------------------------------
// Reducer
// ------------------------------------
const oAuthPortalPermissionsReducer = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
};

export default oAuthPortalPermissionsReducer;
